import { useFormContext } from "react-hook-form";
import {
    TextField,
    Box,
    Stack,
    InputAdornment,
    IconButton,
    Popover,
    Typography,
} from "@mui/material";
import { useTranslatedMessages } from "@/multiLanguage/i18n";
import HelpIcon from "@mui/icons-material/Help";
import { theme } from "@/theme";
import { useState } from "react";

interface InputProps {
    triglycerides?: boolean; //indica se si deve vedere o meno il campo triglycerides
}

function CholesterolData({ triglycerides = true }: InputProps) {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const lang = useTranslatedMessages();
    const [infoTextIsOpen, setInfoTextIsOpen] = useState<boolean>(false);
    const [infoText, setInfoText] = useState<string>("");
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    return (
        <Stack gap={3}>
            {/* Qui puoi inserire altri componenti del form se necessario */}

            <Box height={65}>
                <TextField
                    {...register("totalCholesterol", {
                        valueAsNumber: true,
                        required: lang.scales.cholesterolComponent.totalCholesterol.errorText,
                        validate: (value) => {
                            if (!Number.isInteger(value) || value < 116 || value > 348) {
                                return lang.scales.cholesterolComponent.totalCholesterol.errorText;
                            } else {
                                return true;
                            }
                        },
                    })}
                    data-testid="form-component-totalCholesterol"
                    label={<>{lang.scales.cholesterolComponent.totalCholesterol.label}*</>}
                    type="number"
                    inputProps={{
                        step: ".01",
                        onWheel: (event: any) => {
                            event.target.blur();
                        },
                    }}
                    fullWidth
                    error={!!errors.totalCholesterol}
                    helperText={
                        errors.totalCholesterol ? String(errors.totalCholesterol?.message) : " "
                    }
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                mg/dL
                                <IconButton
                                    onClick={(event) => {
                                        setAnchorEl(event.currentTarget);
                                        setInfoText(
                                            lang.scales.cholesterolComponent.totalCholesterol
                                                .infoText
                                        );
                                        setInfoTextIsOpen(true);
                                    }}
                                    edge="end"
                                >
                                    {<HelpIcon sx={{ color: theme.palette.secondary.light }} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    FormHelperTextProps={{
                        style: {
                            fontSize: '0.65rem', // Cambia la grandezza del testo come preferisci
                        },
                    }}
                />
            </Box>
            <Box height={65}>
                <TextField
                    {...register("hdlCholesterol", {
                        valueAsNumber: true,
                        required: lang.scales.cholesterolComponent.hdlCholesterol.errorText,
                        validate: (value) => {
                            if (!Number.isInteger(value) || value < 27 || value > 97) {
                                return lang.scales.cholesterolComponent.hdlCholesterol.errorText;
                            } else {
                                return true;
                            }
                        },
                    })}
                    data-testid="form-component-hdlCholesterol"
                    label={<>{lang.scales.cholesterolComponent.hdlCholesterol.label}*</>}
                    type="number"
                    inputProps={{
                        step: ".01",
                        onWheel: (event: any) => {
                            event.target.blur();
                        },
                    }}
                    fullWidth
                    error={!!errors.hdlCholesterol}
                    helperText={errors.hdlCholesterol ? String(errors.hdlCholesterol?.message) : " "}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">mg/dL</InputAdornment>,
                    }}
                    FormHelperTextProps={{
                        style: {
                            fontSize: '0.65rem', // Cambia la grandezza del testo come preferisci
                        },
                    }}
                />
            </Box>

            {triglycerides && (
                <Box height={65}>
                    <TextField
                        {...register("triglycerides", {
                            valueAsNumber: true,
                            required: lang.scales.cholesterolComponent.triglycerides.errorText,
                            validate: (value) => {
                                if (!Number.isInteger(value) || value < 7 || value > 13975) {
                                    return lang.scales.cholesterolComponent.triglycerides.errorText;
                                } else {
                                    return true;
                                }
                            },
                        })}
                        data-testid="form-component-triglycerides"
                        label={<>{lang.scales.cholesterolComponent.triglycerides.label}*</>}
                        type="number"
                        inputProps={{
                            step: ".01",
                            onWheel: (event: any) => {
                                event.target.blur();
                            },
                        }}
                        fullWidth
                        error={!!errors.triglycerides}
                        helperText={
                            errors.triglycerides ? String(errors.triglycerides?.message) : " "
                        }
                        InputProps={{
                            endAdornment: <InputAdornment position="end">mg/dL</InputAdornment>,
                        }}
                        FormHelperTextProps={{
                            style: {
                                fontSize: '0.65rem', // Cambia la grandezza del testo come preferisci
                            },
                        }}
                    />
                </Box>
            )}
            <Popover
                open={infoTextIsOpen}
                anchorEl={anchorEl}
                onClose={() => {
                    setInfoTextIsOpen(false);
                }}
                disableScrollLock
                transformOrigin={{
                    horizontal: "left",
                    vertical: "bottom",
                }}
            >
                <Typography sx={{ p: 2 }}>{infoText}</Typography>
            </Popover>
        </Stack>
    );
}

export default CholesterolData;
